import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SkeletonLoadingComponent } from '@shared/components/skeleton-loading/skeleton-loading.component';

@Component({
  selector: 'product-loading',
  templateUrl: './product-loading.component.html',
  styleUrl: './product-loading.component.scss',
  imports: [CommonModule, RouterModule, TranslateModule, SkeletonLoadingComponent],
})
export class ProductLoadingComponent {}
